const productionsLocalize = {
  "All manufactures are refused": "All manufactures are refused",
  "This manufacture has already been canceled": "This manufacture has already been canceled"
};

export default productionsLocalize;
